const cacheVersion = process.env.REACT_APP_CACHE_VERSION;

export function deleteStorage(key) {
    localStorage.removeItem(key);
    localStorage.setItem('cache_version', cacheVersion);
}
